<!--
  @description 部门首页事项模板1
  @author cjs1992
  @date 2020-10-22 13:14:45
-->
<template>
  <div>
    <!-- 遍历事项列表 -->
    <template v-for="(item, index) in guidelineList">
      <div
        class="guideline_item"
        :key="index"
      >
        <div class="guideline_item_wrap">
          <img
            :src="`/portal-ywtb/${item.guidelineImg}`"
            style="width: 36px;height: 36px;margin-right: 20px;"
          />
          <span class="guideline_name">{{item.portalPcHandlingGuidelineName}}</span>
          <div class="rate_wrap">
            <Rate
              :value="item.guidelineSatisfaction || 0"
              disabled
            >
            </Rate>
          </div>
        </div>
        <!-- hover后显示区域 -->
        <div class="hover_show_wrap">
          <button
            class="hover_btn"
            @click="bsznFunc(item)"
            v-if="String(item.portalPcHandlingGuideline) === '1'"
          >
            <i class="iconfont icon-banshizhinan"></i>
            办事指南</button>
          <button
            class="hover_btn"
            @click="zxblFunc(item)"
            v-if="[ null, undefined, '' ].indexOf(item.guidelineUrl) === -1 && item.ljbl === 1"
          >
            <i class="iconfont icon-banli"></i>
            在线办理</button>
          <template v-if="$store.state.isLogin">
            <button
              class="hover_btn"
              v-if="item.portalPcHandlingGuidelineCollection === 1"
              @click="scFunc(item)"
            >
              <i class="iconfont icon-sc"></i>
              取消收藏</button>
            <button
              class="hover_btn"
              v-else
              @click="scFunc(item)"
            >
              <i class="iconfont icon-sc"></i>
              我要收藏</button>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Rate from "@/components/rate/main.vue";
export default {
  components: {
    Rate
  },
  props: {
    guidelineList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  inject: ["bsznFunc", "zxblFunc", "scFunc"],
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.guideline_item {
  margin-bottom: 10px;
  &:hover {
    .hover_show_wrap {
      height: 44px;
    }
    .guideline_item_wrap {
      background-color: #374da3;
      .guideline_name {
        color: #fff;
      }
      &::before {
        background-color: #5bb8f3;
      }
    }
  }
}
.guideline_item_wrap {
  height: 50px;
  background-color: #f5f5f5;
  color: #5a5a5a;
  font-size: 14px;
  line-height: 50px;
  padding-left: 20px;
  position: relative;
  /*&::before {
    content: " ";
    position: absolute;
    background-color: #4566e0;
    width: 4px;
    height: 12px;
    top: 19px;
    left: 0;
  }*/
  .rate_wrap {
    position: absolute;
    right: 20px;
    top: 16px;
    &::before {
      content: " ";
      position: absolute;
      background-color: transparent;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99;
    }
    /deep/ {
      .el-rate__item {
        width: 28px;
      }
      .el-rate__icon.el-icon-star-off {
        color: #ffb32e !important;
      }
      .el-icon-star-on {
        font-size: 20px;
      }
    }
  }
}
.hover_show_wrap {
  // display: none;
  // height: 43px;
  height: 0;
  background-color: #fff;
  transition: all linear 0.3s;
  overflow: hidden;
  .hover_btn {
    width: 100px;
    height: 28px;
    box-sizing: border-box;
    margin-top: 16px;
    margin-left: 16px;
    border: none;
    color: #fff;
    border-radius: 14px;
    border: 1px solid #4772bd;
    background-color: #fff;
    text-align: center;
    color: #4772bd;
    line-height: 26px;
    cursor: pointer;
    &:focus {
      outline: none;
    }
    .iconfont {
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/dept-home-guideline/template-2.vue